(function () {

  const hamburger = document.getElementById('hamburgerBtn');
  const overlay   = document.getElementById('overlay');
  const drawer    = document.getElementById('mobileDrawer');
  const closeBtn  = document.getElementById('closeDrawer');

  const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

  /* Open Drawer */
  function openDrawer() {
    drawer.classList.add('open');
    overlay.classList.add('open');
    hamburger.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  /* Close Drawer */
  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    hamburger.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* Dropdown Toggle */
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e){
      e.preventDefault();

      const subMenu = this.nextElementSibling;

      if(subMenu){
        subMenu.classList.toggle('open');
      }
    });
  });

  /* Events */
  hamburger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

})();


document.addEventListener('DOMContentLoaded', function () {
        const getQuantity = $('.hdt-product-form__quantity').parent().clone();
      $('.hdt-product-form__quantity').parent().remove();
      $('.hdt-product-form__buttons').prepend(getQuantity);
  const switchBtns = document.querySelectorAll('.switch-btn');
  const mixes = document.querySelector('.mixes-group');
  const flavors = document.querySelector('.flavors-group');

  const selectionType = document.getElementById('selection-type');
  const selectedOption = document.getElementById('selected-option');

  // SWITCH
  switchBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      switchBtns.forEach((b) => b.classList.remove('active'));
      this.classList.add('active');

      let type = this.dataset.type;
      selectionType.value = type;

      if (type === 'Mixes') {
        mixes.style.display = 'block';
        flavors.style.display = 'none';
      } else {
        mixes.style.display = 'none';
        flavors.style.display = 'block';
      }

      // reset selection
      selectedOption.value = '';
      document.querySelectorAll('.variant-btn').forEach((b) => b.classList.remove('active'));
    });
  });

  // OPTION SELECT
  document.querySelectorAll('.variant-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.variant-btn').forEach((b) => b.classList.remove('active'));
      this.classList.add('active');

      selectedOption.value = this.dataset.value;
    });
  });

  // VALIDATION (IMPORTANT)
    
});


document.addEventListener("click", function (e) {
  if (e.target.classList.contains("hdt-quantity__button")) {

    const input = e.target.closest("form").querySelector('input[name="quantity"]');

    if (input && input.max == "1") {
      setTimeout(() => {
        if (parseInt(input.value) > 1) {
          input.value = 1;
          alert("This product can only be purchased once (quantity = 1).");
        }
      }, 0);
    }

  }
});